// import { canUseDOM } from 'exenv';

export function categoryPageLoading(resp = {}, store = {}) {
  return {
    type: 'CATEGORY_PAGE_LOADING',
    categoryPage: resp,
    store
  };
}

export function categoryPageLoaded(resp = {}, store = {}) {
  return {
    type: 'CATEGORY_PAGE_LOADED',
    categoryPage: resp,
    store
  };
}

export function categoryPageLoadError(error, store = {}) {
  return {
    type: 'CATEGORY_PAGE_ERROR',
    categoryPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
